import React from 'react';
import "../styling/Navigation.css"

import { NavLink } from 'react-router-dom';
 
const Navigation = () => {
    return (
       <div id='navigation-bar'>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/about">About</NavLink>
          <NavLink to="/contact">Contact</NavLink>
       </div>
    );
}
 
export default Navigation;